module.exports = __webpack_public_path__ + "static/img/icon_float_nav_ai_tutor.911fa98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_float_nav_ai_tutor.svg
// module id = QGa0
// module chunks = 10